import React, { Component } from "react";
import { connect } from "react-redux";
import Parse from "parse";
import { parseAction } from "../../../actions/REST";
import config from "../../../config";
import AccountContainer from "./AccountContainer";
import CorporateContainer from "./CorporateContainer";
import CorporateSetting from "./CorporateSetting";
import PrescriptionContainer from "./PrescriptionContainer";
import TeamContainer from "./TeamContainer.js";
import NotificationSetting from "./NotificationSetting.js";
import SubscriptionContainer from "./Subscription/SubscriptionContainer";
import OrganizationContainer from "./OrganizationContainer.js";
import QRQueueModal from "../../Conversation/QRQueueModal/index.js";
import Switch from "react-switch";
import {
  showProfileSidebar,
  hideProfileSidebar,
  showAccount,
  hideAccount,
  showQRQueueModal,
  setQRQueueModalDemo,
} from "../../../actions/GlobalAction";
import UserScheduleModal from "./UserSchedule.js";
import UserAvailability from "./UserAvailability.js";
import { getMembersSchedule, updateUser } from "../../../actions/ProfileAction.js";
import { stopQueue } from "../../../actions/PatientAction.js";
import "./ProfileSetting.css";

const pckgeJSON = require("../../../../package.json");

const $ = window.$;

export class ProfileSetting extends Component {
  constructor() {
    super();
    this.state = {
      user: "",
      profilePictureURL: "",
      willUpdateUserProfile: false,
      savingUserProfile: false,
      willUpdateCompany: false,
      savingCompany: false,
      willUpload: false,
      isUploading: false,
      // isAvailable: true,
      isCriticalTask: false,
      isStatusModal: false,
      reason: "",
      openUserSched: false,
      // useSchedule: false,
      awayStatusConfirmModal: false,
      qrCodeModalShown: false,
    };

    this._renderAccount = this._renderAccount.bind(this);
  }

  componentDidMount() {
    // this.props.getMembersSchedule();
  }

  componentWillUnmount() {
    this.closeNav();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.profileSidebarShown) {
      this.openNav(newProps.openAccount);
    } else {
      this.closeNav();
    }
  }

  openNav(openAccount) {
    if (openAccount) {
      this.refs.mySidenav.style.width = "850px";
      this.refs.blur.style.width = "100%";
    } else {
      this.refs.mySidenav.style.width = "350px";
      this.refs.blur.style.width = "100%";
    }
  }

  closeNav() {
    let image = this.state.profilePictureURL;
    let picture = Parse.User.current().get("picture");
    if (typeof picture != "undefined") {
      image = picture._url;
    } else {
      image = require("../../../assets/images/default.png");
    }
    this.setState({
      willUpdateUserProfile: false,
      willUpdateCompany: false,
      isUploading: false,
      willUpload: false,
      profilePictureURL: image,
    });
    this.props.hideAccount();
    this.refs.mySidenav.style.width = "0";
    this.refs.blur.style.width = "0";
  }

  handleCloseNav() {
    this.props.hideProfileSidebar();
  }

  openUserSched() {
    this.setState({ openUserSched: true });
  }

  logoutUser() {
    // const qrCode = localStorage.getItem("current-qr-code");
    // if (qrCode) {
    //   this.props.stopQueue(qrCode);
    //   localStorage.removeItem("current-qr-code");
    // }
    Parse.User.logOut().then(() => {
      // localStorage.removeItem("activeTab");
      localStorage.removeItem("recentMesages");
      localStorage.setItem("is_logged_in", false);
      // localStorage.clear();
      window.location.href = "/";
    });
  }

  toggleAccount(type) {
    if (type === this.props.accountType) {
      if (this.props.openAccount) {
        this.refs.mySidenav.style.width = "350px";
        this.props.hideAccount(type);
      } else if (!this.props.openAccount) {
        this.refs.mySidenav.style.width = "850px";
        this.props.showAccount(type);
      }
    } else {
      this.refs.mySidenav.style.width = "850px";
      this.props.showAccount(type);
    }
    this.refs.blur.style.width = "100%";
  }

  _renderAccount() {
    switch (this.props.accountType) {
      case "account":
        return <AccountContainer />;
        break;

      case "corporate":
        // return <CorporateContainer />;
        // return <CorporateSetting />;
        break;

      case "prescription":
        return <PrescriptionContainer />;
        break;

      case "teams":
        return <TeamContainer />;
        break;

      case "subscription":
        return <SubscriptionContainer openAccount={this.props.openAccount} />;
        break;

      case "notification":
        return <NotificationSetting notificationType={this.props.notificationType} />;
        break;

      case "organization":
        return <OrganizationContainer />;
        break;
    }
  }

  openStatusModal(checked) {

    if (checked === false) {
      const modal = document.getElementById("blur");
      modal.style.opacity = "0.9";
      this.setState({
        isStatusModal: true,
        // isAvailable: false,
        // useSchedule: false,
      });
    } else {
      // const user = Parse.User.current();
      // user.set({ 
      //   isAvailable: true,
      //   useSchedule: false,
      //   unavailabilityReason: "",
      // });
      // user.save();
      const action = {
        isAvailable: true,
        useSchedule: false,
        unavailabilityReason: "",
      }
      this.props.updateUser(action);

      parseAction(
        "post",
        config.BASE_URL + "/parse/functions/updateAvailability",
        {
          isAvailable: true,
          useSchedule: false,
        },{
          "Content-Type": "application/json",
        }
      )
    }
  }

  handleUserUpdateSchedule(sched) {
    if (sched.length === 0) {
      const action = {
        isAvailable: false,
        useSchedule: false,
        unavailabilityReason: "",
      }
      this.props.updateUser(action);
    } else {
      // parseAction(
      //   "post",
      //   config.BASE_URL + "/parse/functions/updateAvailability",
      //   {
      //     isAvailable: true,
      //     useSchedule: true,
      //   },{
      //     "Content-Type": "application/json",
      //   }
      // );
      const action = {
        isAvailable: true,
        useSchedule: true,
        unavailabilityReason: "",
      }
      this.props.updateUser(action);
    }
  }

  handleChange(res) {
    const modal = document.getElementById("blur");
    modal.style.opacity = "1.0";
    
    if (res || res === "") {
      const today = new Date().toISOString().slice(0, 10); // Format: YYYY-MM-DD
      localStorage.setItem('awayLastShownDate', today);
      const action = {
        isAvailable: false,
        useSchedule: false,
        unavailabilityReason: res,
      }
      this.props.updateUser(action);
      // this.setState({ reason: res });
      parseAction(
        "post",
        config.BASE_URL + "/parse/functions/updateAvailability",
        {
          isAvailable: false,
          useSchedule: false,
          unavailabilityReason: res,
        },{
          "Content-Type": "application/json",
        }
      )
      .then(() => {
        const action = {
          isAvailable: false,
          useSchedule: false,
          unavailabilityReason: res,
        }
        this.props.updateUser(action);
      });
    } else {
      // this.setState({ isAvailable: true });
    }
    this.setState({ isStatusModal: false });
  }

  handleCriticalTask(checked) {
    this.setState({
      isCriticalTask: checked,
    });
  }

  openCorporateView() {
    const { activeThread } = this.props;
    const filesUrl = [window.location.origin, "/corporate-view"].join("");
    // const filesUrl = [window.location.origin, "/corporate-setting"].join("");
    window.open(filesUrl, "Hubchart Corporate");
  }

  closeStatusModal() {
    this.setState({
      isStatusModal: false,
      openUserSched: false,
      awayStatusConfirmModal: false,
      qrCodeModalShown: false,
    });
  }

  openAwayConfirmModal() {
    this.setState({
      awayStatusConfirmModal: true,
    });
  }

  openQrCodeModalShown() {
    const uuid = Parse.User.current() ? Parse.User.current().id : "";
    this.props.showQRQueueModal();
    if (!(localStorage.getItem("hubchart-app-demo-code-view-", + uuid)) || false) {
      this.props.setQRQueueModalDemo(true);
    }
    this.setState({
      qrCodeModalShown: true,
    })
  }

  toggleBox() {
    const box = document.getElementById("box");
    box.classList.toggle("open");
    const chevron = document.getElementById("user-status-chevron");
    chevron.classList.toggle("rotate-180");
  }

  render() {
    let userObject = JSON.stringify(Parse.User.current().toJSON());
    userObject = JSON.parse(userObject);

    let imageURL = require("../../../assets/images/default.png");
    if (userObject.picture) {
      if (userObject.picture.url) {
        imageURL = userObject.picture.url;
      }
    }
    let Name = "";
    let Email = "";

    if (userObject.displayName) Name = Parse.User.current().get("displayName");
    if (userObject.email) Email = Parse.User.current().get("email");

    let statusStyle = {
      padding: "0",
      fontSize: "12px",
      fontWeight: "500",
      color: "rgb(95, 93, 93)",
      whiteSpace: "pre-wrap",
    };

    const versionNumber = pckgeJSON.version;
    
    const { isAvailable, useSchedule, unavailabilityReason } = this.props.userProfile;

    return (
      <div>
        <div ref="blur" className="blur" onClick={this.handleCloseNav.bind(this)}></div>
        <div id="blur" ref="mySidenav" className="Profile-Setting-Nav">
          <a href="#!" className="closebtn" onClick={this.handleCloseNav.bind(this)}>
            <i className="fas fa-times fa-fw"></i>
          </a>
          <div
            className="setting-container"
            style={{
              width: "351px",
              borderRight: "1px solid rgba(0,0,0,0.12)",
            }}
          >
            <div id="hc-profile-setting-profile" className="img-container">
              <img src={imageURL} alt="Group Profile Picture" />
              <p>{Name}</p>
              <p className="hc-primary-text p-0">{Email}</p>
              <p style={statusStyle}>{userObject.statusMessage}</p>
            </div>
            <div
              id="hc-profile-setting-status"
              className="detail-container"
              style={{ background: "transparent", paddingBottom: "0px" }}
            >
              <div
                className="action hover-primary d-flex"
                style={{ alignItems: "center" }}
                onClick={() => this.toggleBox()}
              >
                {isAvailable ? 
                  useSchedule ? (
                    <div className="fa fa-calendar user-status-options user-status-schedule"></div>
                  ) : (
                    <div className="user-status-active"></div>
                ) : (
                  <div className="user-status-not-active"></div>
                )}
                <div className="user-status-options">
                  {isAvailable ? useSchedule ? "Scheduled" : "Available" : "Away" }
                </div>
                <div className="ellipsis" title={unavailabilityReason}>
                  { unavailabilityReason && unavailabilityReason !== "" ? "(" + unavailabilityReason + ")" : "" }
                </div>
                <i
                  id="user-status-chevron"
                  className="fas fa-caret-down"
                  style={{
                    marginLeft: "auto",
                    lineHeight: "0px",
                  }}></i>
              </div>
            </div>
            <div id="box" className="availability-options box">
              <div
                className=""
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#1fab42",
                  margin: "10px"
                }}
              >
              </div>
              <div className="user-status-options" onClick={() => this.openStatusModal(true)}>
                Available
              </div>
              <div style={{ marginLeft: "auto" }}>
                {isAvailable === true && useSchedule === false && (
                  <i className="fas fa-check"
                    style={{
                      color: "#2194f3",
                      lineHeight: "0px",
                      margin: "0px 20px",
                    }}></i>
                )}
              </div>
              <div
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#89888e",
                  margin: "10px"
                }}
              >
              </div>
              <div className="user-status-options" onClick={() => this.openStatusModal(false)}>
                Away
              </div>
              <div style={{ marginLeft: "auto" }}>
                {isAvailable === false && (
                  <i className="fas fa-check"
                    style={{
                      color: "#2194f3",
                      lineHeight: "0px",
                      margin: "0px 20px",
                    }}></i>
                )}
              </div>
              <i className="fa fa-calendar user-status-options"></i>
              <div className="user-status-options" onClick={() => {this.openUserSched(true)}}>
                Set weekly schedule
              </div>
              <div style={{ marginLeft: "auto" }}>
                {isAvailable === true && useSchedule === true && (
                  <i className="fas fa-check"
                    style={{
                      color: "#2194f3",
                      lineHeight: "0px",
                      margin: "0px 20px",
                    }}></i>
                )}
              </div>
              <div style={{ height: "20px" }}></div>
            </div>
            {/* <div className="detail-container" style={{ background: "transparent" }}>
              <span className="action hover-primary">
                <i className="fas fa-id-badge fa-fw" style={{ margin: "0 10px" }}></i>
                <label>
                  Available
                  <Switch
                    onChange={(e) => this.openStatusModal(e)}
                    checked={this.state.isAvailable}
                    onColor="#b6e0ff"
                    onHandleColor="#2693e6"
                    handleDiameter={20}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={15}
                    width={30}
                    className="react-switch ml-1 shift-down-4"
                    id="material-switch"
                  />
                </label>
              </span>
              <label style={{ margin: "0 10px", fontSize: "small"}}>{this.state.reason}</label>
            </div> */}
            <div className="detail-container" style={{ background: "transparent" }}>
              <p className="action hover-primary" onClick={this.toggleAccount.bind(this, "account")}>
                <i className="fas fa-user-alt fa-fw" style={{ margin: "0 10px" }}></i>
                My Profile
              </p>
            </div>
            <div
              id="hc-profile-setting-qr-code"
              className="detail-container"
              style={{ background: "transparent" }}
            >
              <p className="action hover-primary" onClick={this.openQrCodeModalShown.bind(this)}>
                <i className="fad fa-fw fa-qrcode" style={{ margin: "0 10px" }}></i>
                QR Code
              </p>
            </div>
            <div
              id="hc-profile-setting-my-org"
              className="detail-container"
              style={{ background: "transparent" }}
            >
              <p className="action hover-primary" onClick={this.toggleAccount.bind(this, "organization")}>
                <i className="fas fa-city fa-fw" style={{ margin: "0 10px" }}></i>
                My Organization
              </p>
            </div>
            {this.props.userEnabledTabs.includes("Manage My Teams") &&
              <div className="detail-container" style={{ background: "transparent" }}>
                <p className="action hover-primary" onClick={this.toggleAccount.bind(this, "teams")}>
                  <i className="fas fa-users fa-fw" style={{ margin: "0 10px" }}></i>
                  Manage My Teams
                </p>
              </div>
            }
            {/* <div className="detail-container" style={{ background: "transparent" }}>
              <p className="action hover-primary" onClick={this.toggleAccount.bind(this, "notification")}>
                <i className="fas fa-bell fa-fw" style={{ margin: "0 10px" }}></i>
                Notifications
              </p>
            </div> */}
            {/* <div
              className="detail-container action hover-primary"
              style={{ background: "transparent", display:'flex', color:'black' }}
            >
              <span className="">
                <i
                  className="fas fa-exclamation-triangle mr-1"
                  style={{ margin: "0 10px" }}
                ></i>
              </span>  
              <div style={{display:'inline'}}>
                Critical Task Pop-up
                <div style={{fontSize:'9px'}}>Pop-up every 5 mins</div>
              </div>                  
              <Switch
                onChange={(e) => this.handleCriticalTask(e)}
                checked={this.state.isCriticalTask}
                onColor="#b6e0ff"
                onHandleColor="#2693e6"
                handleDiameter={20}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={15}
                width={30}
                className="react-switch ml-1 shift-down-4"
                id="critical-switch"
              />
            </div> */}
            {this.props.userEnabledTabs.includes("Prescription Settings") &&
              <div className="detail-container" style={{ background: "transparent" }}>
                <p className="action hover-primary" onClick={this.toggleAccount.bind(this, "prescription")}>
                  <i className="fas fa-prescription fa-fw" style={{ margin: "0 10px" }}></i>
                  Prescription Settings
                </p>
              </div>
            }
            {/* {this.props.userEnabledTabs.includes("Corporate Account") &&
              <div className="detail-container" style={{ background: "transparent" }}>
                <p className="action hover-primary" onClick={this.openCorporateView.bind(this)}>
                  {" "}
                  <i className="fas fa-city fa-fw" style={{ margin: "0 10px" }}></i>
                  Corporate Account
                </p>
              </div>
            } */}
            {/* <div className="detail-container" style={{background: "transparent"}}>
                            <p className="action hover-primary" onClick={this.toggleAccount.bind(this, "subscription")}><i className="fas fa-edit fa-fw" style={{margin: "0 10px"}}></i>Subscription / Upgrades</p>
                        </div> */}
            {/* <div className="detail-container" style={{ background: "transparent" }}>
              <p className="action hover-primary">
                <i className="fas fa-balance-scale fa-fw" style={{ margin: "0 10px" }}></i>
                Legal
              </p>
            </div> */}
            <div className="detail-container" style={{ background: "transparent" }}>
              <p className="action hover-primary">
                <i className="fas fa-info-circle fa-fw" style={{ margin: "0 10px" }}></i>
                About
              </p>
            </div>
            <div className="detail-container" style={{ background: "transparent" }}>
              <p className="action hover-primary" onClick={this.logoutUser.bind(this)}>
                <i className="fas fa-sign-out-alt fa-fw" style={{ margin: "0 10px" }}></i>
                Logout
              </p>
            </div>
            <div className="version-container">
              <span className="version-text">{`Ver ${versionNumber}`}</span>
            </div>
          </div>

          <div>{this._renderAccount()}</div>
        </div>
        {this.state.qrCodeModalShown && (
          <QRQueueModal
            isOpen={this.state.qrCodeModalShown}
            onClose={this.closeStatusModal.bind(this)}
          />
        )}
        {this.state.isStatusModal && (
          <UserAvailability
            isOpen={this.state.isStatusModal}
            modalClose={this.closeStatusModal.bind(this)}
            handleChange={this.handleChange.bind(this)}
            openAwayConfirmModal={this.openAwayConfirmModal.bind(this)}
            unavailabilityReason={this.props.unavailabilityReason}
          />
        )}
        {this.state.openUserSched && (
          <UserScheduleModal
            isOpen={this.state.openUserSched}
            modalClose={this.closeStatusModal.bind(this)}
            handleUserUpdateSchedule={this.handleUserUpdateSchedule.bind(this)}
          />
        )}
        {this.state.awayStatusConfirmModal && (
          <AwayStatusConfirmation
            openUserSched={this.openUserSched.bind(this, true)}
            onClose={this.closeStatusModal.bind(this)}
          />
        )}
      </div>
    );
  }
}

const AwayStatusConfirmation = ({ openUserSched = () => {}, onClose = () => {} }) => {
  return (
    <div className="user-status-confirmation-modal">
      <div className="user-status-confirmation-container" style={{ width: "auto" }}>
        <div className="save-changes-flex">
          <h5 className="hc-primary-text" style={{ fontSize: "1.25rem" }}>
            Important Reminder !
          </h5>
          <span className="text-sm">Your availability status is set to away.</span>
          <span className="text-sm">Don't forget to update your weekly schedule</span>
          <div style={{ textAlign: "right", marginTop: 10 }}>
            <button
              type="button"
              style={{ marginRight: "10px" }}
              className="btn-hubchart btn-hubchart-close btn-sm schedule-action-cancel"
              onClick={() => onClose()}
            >
              Cancel
            </button>
            <button 
              type="button" 
              className="btn-sm btn-hubchart btn-hubchart-primary schedule-update-save"
              onClick={() => openUserSched(true)}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  profileSidebarShown: state.global.profileSidebarShown,
  openAccount: state.global.openAccount,
  accountType: state.global.accountType,
  notificationType: state.profile.notificationType,
  isAdmin: state.session.isAdmin,
  userProfile: state.profile.userProfile,
  userEnabledTabs: state.profile.userEnabledTabs,
  userEnabledFeatures: state.profile.userEnabledFeatures,
});

export default connect(mapStateToProps, {
  showProfileSidebar,
  hideProfileSidebar,
  showAccount,
  hideAccount,
  getMembersSchedule,
  updateUser,
  showQRQueueModal,
  setQRQueueModalDemo,
  stopQueue,
})(ProfileSetting);
